import React, { Component } from 'react';
import ValidatorRule, { validateRules } from '../utils/ValidatorRulesUtils';

interface IValidatorRenderArgs {
    isValid : boolean,
    message : string
}

type ValidatorState = {
    isValid : boolean,
    message : string
}

interface IValidatorProps {
    fieldName : string,
    render : (renderArgs : IValidatorRenderArgs) => JSX.Element,
    value : any,
    rules : Array<ValidatorRule>
}

class Validator extends Component<IValidatorProps, ValidatorState> {
    state = {
        isValid: true,
        message: ''
    };

    componentDidUpdate(prevProps : IValidatorProps) {
        const { value, rules } = this.props;
        if (prevProps.rules !== rules) {
            this.setState({ isValid: true });
        }
        if (prevProps.value !== value) {
            this.validate();
        }        
    }

    validate = () => {
        const { value, rules, fieldName } = this.props;
        const validation = validateRules(rules, value === null ? "" : value.toString()); //convert to string, otherwise will throw an error

        if (!validation.isValid) {
            const validationRule = validation.validator as ValidatorRule;
            const message = validationRule.formatMessage(fieldName);
            return this.setState({
                isValid: false,
                message
            });
        }
        this.setState({
            isValid: true,
            message: ''
        });
    }

    render() {
        const { render } = this.props;
        const{ isValid, message } = this.state;
        return render({ isValid, message });
    }
}

export {
    Validator, ValidatorRule
};